module.exports = __webpack_public_path__ + "static/media/clear-search.d9cb6ab0.svg";